module.exports = __webpack_public_path__ + "static/media/AdBlockNavIcon.ee8f5da0.svg";